import React, {useCallback} from "react";

import { ReactCompareSlider, ReactCompareSliderImage,ReactCompareSliderHandle } from 'react-compare-slider';

export const Portrait = ({ style, ...props }) => {
  
  const sources= props.sources
  const width =  window.innerWidth;
  return (
  <div
  style={{
      width: "100vw",
      height: "38vw",
      backgroundColor: "black",
  }}>
    <ReactCompareSlider
      {...props}
      itemOne={
        <ReactCompareSliderImage
          src={sources.src1}
          //style={{ filter: "grayscale(1)" }}
          alt="one"
        />
      }
      itemTwo={
        <ReactCompareSliderImage
          src={sources.src2}
          alt="two"
        />
      }
      style={{
        position: "relative",
        width: "60vw",
        left: "20vw",
        ...style
      }}
    />
  </div>
  );
};


export const PortraitMob = ({ style, ...props }) => {

  const sources= props.sources
  const width =  window.innerWidth;
  return (
  <div
  style={{
      width: "100vw",
      height: "60vw",
      backgroundColor: "black",
  }}>
    <ReactCompareSlider
      {...props}
      itemOne={
        <ReactCompareSliderImage
          src={sources.src1}
          //style={{ filter: "grayscale(1)" }}
          alt="one"
        />
      }
      itemTwo={
        <ReactCompareSliderImage
          src={sources.src2}
          alt="two"
        />
      }
      style={{
        position: "relative",
        width: "90vw",
        left: "5vw",
        top: "2vw",
        ...style
      }}
    />
  </div>
  );
};

export default function CompareSlider(props) {

  const json_object = JSON.parse(props.compareSlider)

  return (
    <div>
      {props.isMobile ? 
      <PortraitMob position= {50} sources= {json_object}/>
      : 
      <Portrait position= {50} sources= {json_object}/>
      }
    </div> 
  );
}
